import {useTheme} from "@irati/ui/src/global/useTheme"
import {Body, H2, H3} from "@irati/ui/src/Typography"
import React from "react"
import {StepGridContainer} from "@irati-web/benefits/styled"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import {Card} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {Step} from "./constants"
import Spacing from "@irati/ui/src/Spacing"

interface FourStepsProps {
  steps: Step[]
  headerMessageId?: string
  stepsPerRow?: number
}

export const FourSteps: React.FC<FourStepsProps> = ({
  steps,
  headerMessageId = "platform.payrollpay.store.landing.c2w.steps.header",
  stepsPerRow = 2
}) => {
  const theme = useTheme()
  const {formatMessage} = useIntl()

  return (
    <Spacing marginTop={6} marginBottom={6}>
      <H2 color={theme.colors.primary2} marginBottom={3}>
        <FormattedMessage id={headerMessageId} />
      </H2>
      <StepGridContainer stepsPerRow={stepsPerRow}>
        {steps &&
          steps.map((item, index) => (
            <Card key={index}>
              <Flex direction="column" alignItems="flex-start" gap={1.5}>
                <img src={formatMessage({id: item.image})} alt={item.image} />
                {item.title && (
                  <H3 weight="bold" color={theme.colors.greys.black}>
                    {formatMessage({id: item.title})}
                  </H3>
                )}
                {item.subTitle && (
                  <Body large color={theme.colors.greys.grey50}>
                    {formatMessage({id: item.subTitle})}
                  </Body>
                )}
              </Flex>
            </Card>
          ))}
      </StepGridContainer>
    </Spacing>
  )
}
